export default "__VITE_ASSET__BpclgQyD__"